import routeNames from '@routes/routeNames';
import messages from './messages';
import { permission } from '../../../containers/admin/Secure/permission';

export const JOIN_LINK = {
  route: 'Dashboard',
  params: {},
  label: messages.linkJoin,
  analyticID: 'join'
};

export const HELP_SUPPORT_LINK = {
  route: 'HelpAndSupport',
  params: {},
  label: messages.linkHelpSupport,
  analyticID: 'help-support',
  routeMatches: ['HelpAndSupport']
};

export const LOGO_LINK = {
  route: 'Home',
  params: {},
  label: messages.linkHome,
  analyticID: 'logo'
};

/**
 * Main links for authenticated users.
 */
export const MAIN_LINKS_AUTHENTICATED = [
  {
    route: 'AccountSettings',
    label: messages.linkAccountSettings,
    analyticID: 'account-settings'
  }
];

export const PRIMARY_NAV_LINKS = [
  {
    route: 'Dashboard',
    params: {},
    label: messages.linkDashboard,
    icon: 'dashboard',
    routeMatches: ['Dashboard', 'Home'],
    analyticID: 'dashboard',
    reqPermission: permission.view.dashboard,
    subMenu: [],
    secondaryNav: []
  },
  {
    route: 'Bookings',
    params: {},
    label: messages.linkBookings,
    icon: 'bookings',
    routeMatches: ['Bookings', 'BookingOverview', 'BookingCreate', 'BookingCreateRoomAssignment'],
    analyticID: 'bookings',
    reqPermission: permission.view.bookingManagement,
    subMenu: [],
    secondaryNav: [
      {
        route: 'Bookings',
        params: {},
        label: messages.linkBookings,
        icon: 'bookings',
        routeMatches: ['Bookings', 'BookingOverview', 'BookingCreate', 'BookingCreateRoomAssignment'],
        analyticID: 'bookings',
        reqPermission: permission.view.bookingManagement,
        tertiaryNav: {
          breadcrumbs: [],
          routes: [
            {
              route: 'Bookings',
              params: {},
              label: '',
              icon: '',
              subMenu: [],
              analyticID: '',
              reqPermission: permission.view.customerManagement,
              routeMatches: ['Bookings']
            }
          ]
        }
      }
    ]
  },
  {
    route: 'Customers',
    params: {},
    label: messages.linkCustomers,
    icon: 'customers',
    subMenu: [],
    analyticID: 'customers',
    reqPermission: permission.view.customerManagement,
    routeMatches: [
      'Customers',
      'CustomerOverview',
      'CustomerMembers',
      'CustomerTrackingCodes',
      'MemberDetails',
      'CustomerPaymentIds',
      'CustomerRates',
      'CustomerPreferences',
      'CustomerFeatureSettings',
      'PendingRequests',
      'FeatureFlags'
    ]
  },
  {
    route: 'Suppliers',
    params: {},
    label: messages.linkSuppliers,
    icon: 'suppliers',
    routeMatches: [
      'Suppliers',
      'SupplierOverview',
      'SupplierProperties',
      'RateCards',
      'RateCardsSelected',
      'ConnectionManagement',
      'RateEngineManagement',
      routeNames.SUPPLIER_PROPERTY_OVERVIEW
    ],
    analyticID: 'suppliers',
    subMenu: []
  },
  {
    route: 'margins',
    params: {},
    label: messages.linkMargins,
    icon: 'margins',
    routeMatches: [routeNames.Margins],
    analyticID: 'margins',
    reqPermission: permission.view.margins,
    subMenu: []
  },
  {
    route: 'Users',
    params: {},
    label: messages.linkUsers,
    icon: 'users',
    routeMatches: ['Users', 'UserOverview', 'Roles', 'Permissions', 'CreatePermission'],
    analyticID: 'users',
    subMenu: []
  },
  {
    route: 'COGS',
    params: {},
    label: messages.linkAccounting,
    icon: 'accounting',
    routeMatches: [
      'COGS',
      'FoliosByBooking',
      'FolioMissing',
      'FolioOverview',
      'Reconciliation',
      'Viewer',
      'Chargesheets',
      'Chargesheet',
      'ChargesheetPreview',
      'ChargesheetFolios',
      'CreateChargesheet',
      'Invoices',
      'InvoiceDetails',
      'DraftInvoiceDetails',
      'VendorBills',
      'VendorBillDetails',
      'DraftVendorBillDetails',
      'TaxTemplates',
      'TaxesAndFees'
    ],
    analyticID: 'accounting',
    subMenu: []
  },
  {
    route: 'AccountManagement',
    params: {},
    label: messages.linkVirtualCardManagement,
    icon: 'vccs',
    routeMatches: ['AccountManagement', 'CardManagement', 'Approvals', 'ApprovalSingle'],
    analyticID: 'vccs',
    subMenu: []
  },
  {
    route: 'Tickets',
    params: {},
    label: messages.linkTickets,
    icon: 'tickets',
    subMenu: [],
    routeMatches: ['Tickets', 'TicketOverview'],
    analyticID: 'tickets'
  }
];

export const MOCK_NOTIFICATIONS = [];
